// extracted by mini-css-extract-plugin
module.exports = {"container":"Bt","detailRateButton":"Bu","fadeIn":"Bv","fadeOut":"Bw","userRatingIcon":"Bx","detailRateButtonLabel":"By","isRental":"Bz"};